/**
 * Counts all tournament statistics and updates the tournament document
 * @param {string} tournamentId - The ID of the tournament
 * @returns {Promise<Object>} - Object containing all counts
 */
const countTournamentStats = async (
  tournamentId,
  closeTimestamp = undefined
) => {
  try {
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(tournamentId);

    // Count all subcollections concurrently
    const [
      teamsSnapshot,
      refereesSnapshot,
      daysSnapshot,
      sportParksSnapshot,
      divisionsSnapshot,
      matchesSnapshot,
      playersSnapshot,
    ] = await Promise.all([
      tournamentRef.collection("teams").get(),
      tournamentRef.collection("referees").get(),
      tournamentRef.collection("days").get(),
      tournamentRef.collection("sportParks").get(),
      tournamentRef.collection("divisions").get(),
      tournamentRef.collection("matches").get(),
      tournamentRef.collection("players").get(),
    ]);

    // Calculate counts
    const stats = {
      numTeams: teamsSnapshot.size,
      numReferees: refereesSnapshot.size,
      numMatchDays: daysSnapshot.size + 1, // Plus 1 for the first date stored separately
      numLocations: sportParksSnapshot.size,
      numDivisions: divisionsSnapshot.size,
      numMatches: matchesSnapshot.size,
      numPlayers: playersSnapshot.size,
      closeTimestamp: closeTimestamp,
    };

    // Update the tournament document with all statistics
    await tournamentRef.update(stats);

    return stats;
  } catch (error) {
    console.error("Error counting tournament statistics:", error);
    throw error;
  }
};

export default countTournamentStats;
